import { useEffect, useState, useCallback, FormEvent, useContext, useLayoutEffect, useMemo } from 'react'
import { GridRowsProp } from '@mui/x-data-grid'
import {
  getArea,
  getData,
  getStore,
  getDepartments,
  getUserTypes,
  getUsers,
  getDivisions,
  cancelFolios,
  deleteFolios,
  getAllDepartmentsWithFoliosId,
  reassignFolios
} from '../methods'
import { useTranslation } from 'react-i18next'
import { handleStatus } from '../../../utils'
import {
  Item,
  ObjectGeneric,
  onChange,
} from '../../../../../../../utils/types/generals'
import { downloadHeaders, filterInputs, formatFilter, listReportFolio, listSchedule, reportFolioServices } from '../constants/states'
import {
  getPreviousYears,
  monthYear,
} from '../../../../../../../utils/constants/date_month'
import { Roles, Status, Types } from '../../../../../../../utils/enums'
import { isEmailSeparateToCome } from '../../../../../../../utils/validate/validate'
import { GlobalContext } from '../../../../../../../contexts/Global'
import { BodyUnit, TypeComponent, DateItems, FoliosAmount, HeaderSimple, PriorityItem, AssigmentComponent, RowCheckbox, NumberOfFolio, PriorityText, Settings, StatusItem, TimeElapsed, UserAssigned, UserCreator, CheckboxHeader, ClickPayload } from '../components'
import { useNavigate } from 'react-router'
import { DashboardReportFolioContext } from '../../../context'
import { useLocation } from 'react-router-dom'
import { removeAllReference } from '../../../../../../../utils/methods/removedReference'
import { CalendarContext } from '../../../../../../calendar/context'
import { NavigatioStateType } from '../../../../../../../utils/enums/navigatetionState'
import { UserScheduleContext } from '../../../../../../userSchedule/context'
import { BreadCrumbKeys } from '../../../../../../../components/breadCrumb/enum'
import { CancelFoliosInterface, DeleteFoliosInterface, reassignFoliosInterface } from '../../../../../../../service/reportFolio/body'
import { DepartmentIdsInterface, DepartmentUser } from './types'
import { FolioType } from '../../../utils/enums/folioType'
import { Priority } from '../../../../../../../utils/enums/priority'
import { CommentCountComponent } from '../components/commentCount'


const useGetData = () => {
  const { t } = useTranslation()
  const navigation = useNavigate()
  const location = useLocation()
  const { state } = useContext(GlobalContext)
  const userId = state?.id
  const roleId = state?.role
  const { role } = state
  const [dependientItems, setDependientItems] = useState<Record<string, Item[]>>({})
  const [inputFilter, setInputFilter] = useState(filterInputs)
  const [headers, setHeaders] = useState<{ label: string; id: string }[]>([])
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState({ resendButton: true, resendButtonLoading: false, })
  const [snackbar, setSnarbar] = useState({ message: '', type: Types.SUCCESS, open: false, })
  const [resendReport, setResndReport] = useState<ObjectGeneric>({ open: false, })
  const [total, setTotal] = useState({ totalPages: 1, totalItems: 0, })
  /* TABLE DATA */
  const [detail, setDetail] = useState({ id: 0, reportUrl: '', positionMenu: {}, status: null })
  const context = useMemo(() => {
    if ([NavigatioStateType.SCHEDULE, NavigatioStateType.SCHEDULE_RECURRENCE].includes(location?.state?.type)) { return CalendarContext }
    if ([NavigatioStateType.USER_SCHEDULE, NavigatioStateType.USER_RECURRENCE].includes(location?.state?.type)) { return UserScheduleContext }
    return DashboardReportFolioContext
  }, [])
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isCreatorOrAdminOrAssing, setIsCreatorOrAdminOrAssing] = useState(false)
  const [localStatus, setLocalStatus] = useState<Status | undefined>()
  const [localType, setLocalType] = useState<FolioType | null>(null)
  const [flagEdit, setFlagEdit] = useState(true)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => { setAnchorEl(event.currentTarget) }
  const { filterData, setFilterPayload } = useContext(context)
  const { isLoading, getDetailInform, uuid } = useContext(DashboardReportFolioContext)
  const [isUserAssigned, setIsUserAssigned] = useState(false)
  const [canReassignUser, setCanReassignUser] = useState(true)
  const [localStatusAttentionId, setLocalStatusAttentionId] = useState()
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    title: '',
    description: '',
    onConfirm: async () => { },
    onClose: () => { },
    //onCancel: () => { }
  })

  const closeConfirmModal = () => {
    setConfirmModal(prev => ({ ...prev, open: false }))
  }


  const closeSnackbar = () => { setSnarbar((prev) => ({ ...prev, open: false, })) }

  const closeResendModal = () => {
    setResndReport({ open: false, })
    closeSnackbar()
    setDisabled((prev) => ({ ...prev, resendButtonLoading: false, resendButton: true, }))
  }

  const submitResendReport = (e?: FormEvent<HTMLFormElement>) => {
    setDisabled((prev) => ({ ...prev, resendButtonLoading: true, }))

    e?.preventDefault()
    const emails = resendReport?.externalEmails
      ?.split(',')
      ?.filter((item: string) => !!item)

    let body: ObjectGeneric = {
      sendCreatedBy: !!resendReport?.sendCreatedBy,
      sendUserAssign: !!resendReport?.sendUserAssign,
      sendManageStore: !!resendReport?.sendManageStore,
    }

    if (!!emails?.length) body.externalEmails = emails

    reportFolioServices
      .resendReportFolio({ id: detail.id, body })
      .then((response) => {
        if (!response?.errors) {
          closeResendModal()
          setSnarbar((prev) => ({
            ...prev,
            open: true,
            message: t('reportFolio.snackbar.sendReport.success'),
            type: Types.SUCCESS,
          }))
        } else {
          setSnarbar((prev) => ({
            ...prev,
            open: true,
            message: t('reportFolio.snackbar.sendReport.ERR_NOT_FOUND'),
            type: Types.ERROR,
          }))
        }
      })
      .finally(() => { setDisabled((prev) => ({ ...prev, resendButtonLoading: false, })) })
  }

  const handleSendReportData: onChange = ({ target }) => {
    const { name, value } = target
    const body = { ...structuredClone(resendReport), [name]: value, }
    /* START EMAIL VALIDATE */
    const emailValue = name === 'externalEmails' ? value : body?.externalEmails
    let emailIsSeparate = false
    emailIsSeparate = !(!emailValue || isEmailSeparateToCome(emailValue))
    /* END EMAIL VALIDATE */
    delete body?.open

    setDisabled((prev) => ({
      ...prev,
      resendButton:
        !Object.values(body ?? {})?.some((item) => !!item) || emailIsSeparate,
    }))

    setResndReport((prev) => ({
      ...prev,
      [name]:
        name === 'externalEmails'
          ? value?.replace(/(\r\n|\n|\r|\s)/gm, '')
          : value,
    }))
  }

  const optionMenu = ({ item }: { item: Item }) => {
    const reassignOption = () => {
      navigation(`/dashboard/report-folio/dashboard/detail/${detail.id}`, {
        state: {
          option: item.value
        }
      })
    }
    const optionMenuItems: { [x: string]: () => void } = {
      '1': () => {
        if (!!detail.reportUrl) window.open(detail.reportUrl, 'blank')
        else {
          reportFolioServices
            .generateReportFolio({ id: detail.id })
            .then((data) => {
              window.open(data.reportUrl, 'blank')
            })
        }
      },
      '2': () => {
        setResndReport({
          open: true,
        })
      },
      '3': () => {
        const queary = new URLSearchParams(location.search)
        const rootPath = queary.get(BreadCrumbKeys.ROOT) ?? ''
        const stateNavigation = {
          state: {
            ...location.state,
            replaceRoutes: {
              ...location?.state?.replaceRoutes ?? {},
              search_folio: {
                search: location?.search,
                state: location?.state
              }
            }
          }
        }

        /* if (isUserAssigned && localType !== FolioType.PREVENTIVE && localStatusAttentionId !== Status.STARTED && (localStatus == Status.WAITING || localStatus == Status.AWAIT_SOLUTION)) {
          setConfirmModal({
            open: true,
            title: 'Confirmación',
            description: '¿Estás seguro que deseas visualizar el detalle de esta solicitud? Al hacerlo modificaras su estatus',
            onConfirm: async () => {
              closeConfirmModal()
              if ([NavigatioStateType.SCHEDULE, NavigatioStateType.SCHEDULE_RECURRENCE].includes(location?.state?.type)) {
                const newRoot = `${rootPath},${listSchedule}`
                navigation(`/dashboard/calendar/report-folio/${detail.id}${location.search.replace(rootPath, newRoot)}`, stateNavigation)
                return
              }
              if ([NavigatioStateType.USER_SCHEDULE, NavigatioStateType.USER_RECURRENCE].includes(location?.state?.type)) {
                const newRoot = `${rootPath},${listReportFolio}`
                navigation(`/dashboard/schedule-user/report-folio/${detail.id}${location.search.replace(rootPath, newRoot)}`, stateNavigation)
                return
              }
              navigation(`/dashboard/report-folio/dashboard/detail/${detail.id}`)
            },
            onClose: () => {
              closeConfirmModal()
            }
          })
        } else { */
          if ([NavigatioStateType.SCHEDULE, NavigatioStateType.SCHEDULE_RECURRENCE].includes(location?.state?.type)) {
            const newRoot = `${rootPath},${listSchedule}`
            navigation(`/dashboard/calendar/report-folio/${detail.id}${location.search.replace(rootPath, newRoot)}`, stateNavigation)
            return
          }
          if ([NavigatioStateType.USER_SCHEDULE, NavigatioStateType.USER_RECURRENCE].includes(location?.state?.type)) {
            const newRoot = `${rootPath},${listReportFolio}`
            navigation(`/dashboard/schedule-user/report-folio/${detail.id}${location.search.replace(rootPath, newRoot)}`, stateNavigation)
            return
          }
          navigation(`/dashboard/report-folio/dashboard/detail/${detail.id}`)
        /* } */

      },
      '4': () => {
        navigation(`/dashboard/report-folio/dashboard/${localType == FolioType.CORRECTIVE ? 'correctivo' : 'preventivo'}/${detail.id}`)
      },
      5: reassignOption,
      6: reassignOption,
      7: reassignOption,
    }
    // setOption(item)
    optionMenuItems[item?.value]?.()
  }

  const [row, setRow] = useState<GridRowsProp>([]);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [allIds, setAllIds] = useState<number[]>([]);
  const [allSelects, setAllSelects] = useState(false)
  const [notFolioSelected, setNotFolioSelected] = useState<number[]>([]);
  const [allDepartmentIds, setAllDepartmentIds] = useState<number[]>([]);
  const [selectedDepartmentIds, setSelectedDepartmentIds] = useState<number[]>([]);
  const [notDepartmentSelected, setNotDepartmentSelected] = useState<number[]>([]);
  const [departmentsWithFolios, setDepartmentsWithFolios] = useState<Item[]>([]);

  const [isChecked, setIsChecked] = useState(false)
  /* const isChecked = selectedIds.length === total.totalItems ||
    (selectedIds.length + notFolioSelected.length === total.totalItems && notFolioSelected.length > 0) */

  const HandleCancelFolios = async (body: CancelFoliosInterface, query?: string) => {
    const response = await cancelFolios(body, query);
    return response;
  };

  const handleClickRow = (eventClick: ClickPayload) => {

    const foundItem = row.find(item => item.id === eventClick.id);
    const dataRow = foundItem
      ? { canReassign: foundItem.canReassign, creatorId: foundItem.creatorId, usersAssigned: foundItem.usersAssigned, existSolutionCaseMgDpto: foundItem.existSolutionCaseMgDpto, status: foundItem.status, type: foundItem.type, priorityId: foundItem.priorityId, existAnyQuote: foundItem.existAnyQuote, statusAttentionId: foundItem.statusAttentionId, idsUserManagersDpto: foundItem.idsUserManagersDpto }
      : null;
    const isAdmin = state.role == Roles.ADMIN
    const isUserDepartmentManager = dataRow?.idsUserManagersDpto.includes(state.id)

    if (dataRow) {
      setIsUserAssigned(dataRow?.usersAssigned?.[0]?.userManageId === userId);
      setLocalStatusAttentionId(dataRow.statusAttentionId)
      setLocalStatus(dataRow.status.value)
      if(dataRow.type == "corrective"){ 
        setLocalType(FolioType.CORRECTIVE)
      }else{
        setLocalType(FolioType.PREVENTIVE)
      }
      if (dataRow.priorityId == Priority.HIGH || dataRow.priorityId == Priority.URGENT || dataRow.existSolutionCaseMgDpto || dataRow.existAnyQuote || dataRow.statusAttentionId == Status.STARTED) {
        setFlagEdit(false)
      } else {
        setFlagEdit(true)
      }

      if (
        (
          (isAdmin || dataRow.canReassign || isUserDepartmentManager || (dataRow.usersAssigned && dataRow.usersAssigned[0]?.userManageId == state.id)) &&
          ![Status.APPROVED, Status.REJECTED, Status.CANCEL, Status.EXPIRED, Status.NOT_FINISHED].includes(dataRow.status.value) &&
          !dataRow.existAnyQuote &&
          !dataRow.existSolutionCaseMgDpto &&
          //!(dataRow.priorityId == Priority.HIGH || dataRow.priorityId == Priority.URGENT) &&
          dataRow.type != FolioType.PREVENTIVE
        ) || ( dataRow?.usersAssigned.length == 0 && dataRow.canReassign)
      ) {
        setCanReassignUser(true)
      } else {
        setCanReassignUser(false)
      }
    } else {
      setLocalStatus(undefined)
    }

    if (isAdmin) {
      setIsCreatorOrAdminOrAssing(true)
    } else if (dataRow?.creatorId || dataRow?.usersAssigned) {
      if (dataRow.creatorId == state.id || isUserDepartmentManager || (dataRow.usersAssigned && dataRow.usersAssigned[0]?.userManageId == state.id)) {
        setIsCreatorOrAdminOrAssing(true)
      } else {
        setIsCreatorOrAdminOrAssing(false)
      }
    } else {
      setIsCreatorOrAdminOrAssing(false)
    }

  }

  const ReassignFolios = async (body: reassignFoliosInterface, query?: string) => {
    const response = await reassignFolios(body, query);
    return response;
  }

  const HandleDeleteFolios = async (body: DeleteFoliosInterface, query?: string) => {
    const response = await deleteFolios(body, query);
    return response;
  };

  const setUniqueDepartmentIds = (ids: number[] | ((prev: number[]) => number[])) => {
    setSelectedDepartmentIds(prevIds => {
      const newIds = typeof ids === 'function' ? ids(prevIds) : ids;
      return newIds;
    });
  };

  const setUniqueNotDepartmentSelected = (ids: number[] | ((prev: number[]) => number[])) => {
    setNotDepartmentSelected(prevIds => {
      const newIds = typeof ids === 'function' ? ids(prevIds) : ids;
      return newIds;
    });
  };

  /* const requestAllIds = useCallback(() => {
    setLoading(true);
    getAllsIds(filterData.query.filter)
      .then((folioIds) => {
        const ids = folioIds.map(item => item.id);
        const departmentIds = folioIds.map(item => item.departmentId);
        setAllIds(ids);
        setAllDepartmentIds(departmentIds);
      })
      .catch((error) => {
        console.error("Error fetching IDs:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filterData.query.filter]); */


  /* const fetchDepartmentsWithFolios = useCallback(async () => {
    try {
      const shouldBeAll = isChecked; // selectedIds.length + notFolioSelected.length === total.totalItems;

      const params: DepartmentIdsInterface = {
        all: shouldBeAll,
        department_ids: shouldBeAll ? [] : selectedDepartmentIds,
        not_department_ids: shouldBeAll ? notDepartmentSelected : []
      };

      const response = (await getAllDepartmentsWithFoliosId(params)) as DepartmentUser[];

      const transformedData = response.map((item: DepartmentUser) => ({
        label: `${item.firstName} ${item.lastName}`,
        value: item.id,
        id: item.id.toString()
      }));

      setDepartmentsWithFolios(transformedData);

    } catch (error) {
      console.error('Error fetching departments with folios:', error);
    }
  }, [
    selectedIds,
    notFolioSelected,
    total.totalItems,
    selectedDepartmentIds,
    notDepartmentSelected
  ]); */

  const fetchDepartmentsWithFolios = async () => {
    try {
      const shouldBeAll = isChecked; // selectedIds.length + notFolioSelected.length === total.totalItems;

      const params: DepartmentIdsInterface = {
        all: shouldBeAll,
        department_ids: shouldBeAll ? [] : selectedDepartmentIds,
        not_department_ids: shouldBeAll ? notDepartmentSelected : []
      };

      const response = (await getAllDepartmentsWithFoliosId(params)) as DepartmentUser[];

      const transformedData = response.map((item: DepartmentUser) => ({
        label: `${item.firstName} ${item.lastName}`,
        value: item.id,
        id: item.id.toString()
      }));

      setDepartmentsWithFolios(transformedData);

    } catch (error) {
      console.error('Error fetching departments with folios:', error);
    }
  };


  /* useEffect(() => {
    fetchDepartmentsWithFolios();
  }, [fetchDepartmentsWithFolios]); */



  const columns: any[] = [
    {
      field: 'checkbox',
      headerName: '',
      label: (
        <CheckboxHeader
          allIds={allIds}
          allDepartmentIds={allDepartmentIds}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          selectedIds={selectedIds}
          selectedDepartmentIds={selectedDepartmentIds}
          setSelectedIds={setSelectedIds}
          setSelectedDepartmentIds={setUniqueDepartmentIds}
          total={total.totalItems}
          notFolioSelected={notFolioSelected}
          notDepartmentSelected={notDepartmentSelected}
          setNotFolioSelected={setNotFolioSelected}
          setNotDepartmentSelected={setUniqueNotDepartmentSelected}
        />
      ),
      renderCell: (params: any) => (
        <RowCheckbox
          id={params.row.id}
          departmentId={params.row.departmentId}
          isChecked={isChecked}
          selectedIds={selectedIds}
          selectedDepartmentIds={selectedDepartmentIds}
          setSelectedIds={setSelectedIds}
          setSelectedDepartmentIds={setUniqueDepartmentIds}
          notFolioSelected={notFolioSelected}
          notDepartmentSelected={notDepartmentSelected}
          setNotFolioSelected={setNotFolioSelected}
          setNotDepartmentSelected={setUniqueNotDepartmentSelected}
          total={total.totalItems}
        />
      ),
    },
    // {
    //   id: 'canResponse',
    //   label: '',
    //   renderCell: (params: any) => <NumberOfFolio {...{ ...params, role }} />,
    // },
    // {
    //   id: 'priority',
    //   label: '',
    //   sortable: true,
    //   renderCell: (params: any) => <PriorityItem {...params} />,
    // },
    {
      id: 'foliosAmount',
      label: t('reportFolio.dashboard.table.requestNumber'),
      sortable: true,
      headerCell: {
        '&.header-cell': {
          '& div': {
            width: '115px',
          },
        },
      },
      renderCell: (params: any) => <FoliosAmount {...params} />,
    },
    {
      id: 'unit',
      label: '',
      sortable: true,
      headerCell: {
        '&.header-cell': {
          '& div': {
            width: '150px',
          },
        },
      },
      column: () => <HeaderSimple value={[t('reportFolio.dashboard.table.areaDepartment'), t('reportFolio.dashboard.table.unitUser')]} />,
      renderCell: (params: any) => <BodyUnit {...params} />,
    },
    {
      id: 'creatorFullName',
      label: t('reportFolio.dashboard.table.creatorFullName'),
      sortable: true,
      renderCell: (params: any) => <UserCreator {...params} />,
    },
    {
      id: 'usersAssigned',
      label: t('reportFolio.dashboard.table.solutionUser'),
      headerCell: {
        '&.header-cell': {
          '& div': {
            width: '120px',
          },
        },
      },
      renderCell: (params: any) => <UserAssigned {...params} />,
    },
    {
      id: 'priority',
      sortable: true,
      label: t('reportFolio.dashboard.table.priorityName'),
      renderCell: (params: any) => <PriorityText {...params} />,
      headerCell: {
        '&.header-cell': {
          '& div': {
            width: '80px',
          },
        },
      },
    },
    {
      id: 'type',
      label: t('reportFolio.dashboard.table.type'),
      renderCell: (params: any) => <TypeComponent {...params} />,
      headerCell: {
        '&.header-cell': {
          '& div': {
            width: '80px',
          },
        },
      },
    },
    {
      id: 'requestDate',
      label: t('reportFolio.dashboard.table.requestDate'),
      sortable: true,
      column: () => <HeaderSimple value={[t('reportFolio.dashboard.table.requestDate'), t('reportFolio.dashboard.table.solveDate')]} />,
      renderCell: (params: any) => <DateItems {...params} />,
      headerCell: {
        '&.header-cell': {
          '& div': {
            width: '100px',
          },
        },
      },
    },
    {
      id: 'typeAssign',
      label: t('reportFolio.dashboard.table.AssignmentType'),
      renderCell: (params: any) => <AssigmentComponent {...params} />,
      headerCell: {
        '&.header-cell': {
          '& div': {
            width: '120px',
          },
        },
      },
    },
    {
      id: 'comment',
      label: t('reportFolio.dashboard.table.comment'),
      renderCell: (params: any) => <CommentCountComponent {...params} />,
      headerCell: {
        '&.header-cell': {
          '& div': {
            width: '60px',
          },
        },
      },
    },
    // {
    //   id: 'timeElapsed',
    //   label: '',
    //   sortable: true,
    //   headerCell: {
    //     '&.header-cell': {
    //       '& div': {
    //         width: '120px',
    //       },
    //     },
    //   },
    //   column: () => <HeaderSimple value={[t('reportFolio.dashboard.table.timeElapsed'), t('reportFolio.dashboard.table.daysElapsed')]} />,
    //   renderCell: (params: any) => <TimeElapsed {...params} />,
    // },
    {
      id: 'status',
      label: t('reportFolio.dashboard.table.status'),
      rowTdStyles: {
        maxWidth: '80px',
      },
      renderCell: (params: any) => <StatusItem {...params} />,
    },
    {
      id: 'settings',
      label: t('general.tags.action'),
      minWidth: '50px',
      renderCell: (params: any) => <Settings {...{ ...params, click: handleClickRow, setDetail, handleClick, rowLength: row?.length, userId, roleId }} />,
    },
  ]

  const getStatus = () => {
    let statusList = Object.values(handleStatus({ t, status: Status.ACTIVE }).listStatus)

    if (role == Roles.STORE) {
      statusList = statusList?.filter((item) => ![Status.ACTIVE].includes(item.value))
    } else {
      statusList = statusList?.filter((item) => ![Status.ACTIVE].includes(item.value))
    }
    setInputFilter(prev => ({
      ...prev,
      status: {
        ...prev.status,
        items: statusList ?? [],
      }
    }))
  }

  const requestTable = useCallback(
    (data?: { query?: string | undefined }) => {
      setLoading(true);
      getData(data)
        .then((list) => {
          const newRows = list?.rows?.map((itemRows) => ({
            ...itemRows,
            statusHeader: handleStatus({ t, status: itemRows.status.value })?.statusSelected?.label,
          }));

          setTotal({
            totalItems: list?.totalItems ?? 0,
            totalPages: list?.totalPages ?? 1,
          });
          setRow(newRows);

        })
        .finally(() => {
          setLoading(false);
        });
    },
    [t, total.totalItems]
  );

  const getDate = () => {
    const monthList = monthYear.map((e) => ({
      ...e,
      value: e.value + 1,
    }))
    const listYears = getPreviousYears()
    const listResponse = [
      { label: t('reportFolio.requested'), value: 'false' },
      { label: t('reportFolio.toBeAttended'), value: 'true' },
    ]
    setInputFilter(prev => ({
      ...prev,
      createYear: {
        ...prev.createYear,
        items: listYears,
      },
      month: {
        ...prev.month,
        items: monthList,
      },

      canResponse: {
        ...prev.canResponse,
        items: listResponse ?? [],
      },
    }))
  }

  const getAllDivisions = async () => {
    const list = await getDivisions()
    setInputFilter(prev => ({
      ...prev,
      division: {
        ...prev.division,
        items: list ?? [],
      }
    }))
  }

  const getAllUserTypes = async () => {
    const list = await getUserTypes()
    setInputFilter(prev => ({
      ...prev,
      userType: {
        ...prev.userType,
        items: list ?? [],
      }
    }))
  }

  const getAllUsers = async () => {
    const list = await getUsers()

    setInputFilter(prev => ({
      ...prev,
      user: {
        ...prev.user,
        items: list ?? [],
      }
    }))
  }

  const getAllUnits = async () => {
    const list = await getStore()


    setInputFilter(prev => ({
      ...prev,
      unit: {
        ...prev.unit,
        items: list ?? [],
      }
    }))
  }

  const getAllAreas = async () => {
    const list = await getArea()

    setInputFilter(prev => ({
      ...prev,
      area: {
        ...prev.area,
        items: list ?? [],
      }
    }))
  }

  const getAllDepartments = async () => {
    const list = await getDepartments()
    setDependientItems((prev) => ({
      ...prev,
      department: list ?? [],
    }))
    const newDepartments = list?.filter((e: any) => filterData?.filterData?.area?.find((e2: any) => e2.value == e.areaId))

    setInputFilter(prev => ({
      ...prev,
      department: {
        ...prev.department,
        items: newDepartments ?? [],
      }
    }))
  }

  const getAllPriorities = () => {
    const list = [
      {
        id: "1",
        label: "Urgente",
        value: Priority.URGENT
      },
      {
        id: "1",
        label: "Alta",
        value: Priority.HIGH
      },
      {
        id: "2",
        label: "Media",
        value: Priority.MEDIUM
      },
      {
        id: "3",
        label: "Baja",
        value: Priority.LOW
      }
    ];

    setInputFilter(prev => ({
      ...prev,
      priority: {
        ...prev.priority,
        items: list
      }
    }));
  }

  useEffect(() => {
    setHeaders(downloadHeaders({ t }))
    getAllDivisions()
    getAllUserTypes()
    getAllUsers()
    getAllUnits()
    getAllAreas()
    getAllDepartments()
    //requestAllIds();
    getDate()
    getStatus()
    getAllPriorities()
    //eslint-disable-next-line
  }, [])

  useLayoutEffect(() => {
    setFilterPayload({
      formatFilter,
      externalValidation: ({ name, body, setFilterData, value }) => {
        let copyBody: Record<string, any> = removeAllReference(body)
        if (name === 'area') {
          const { department } = copyBody
          const newDepartments = department?.filter((e: any) => value.find((e2: any) => e2.value == e.areaId))
          let arrayChilds: any[] = []

          value?.forEach((e: any) => {
            const id = e.value
            const childs = dependientItems?.department?.filter((child) => child.areaId == id)
            arrayChilds.push(...childs)
          })

          setInputFilter(prev => ({
            ...prev,
            department: {
              ...prev.department,
              items: arrayChilds ?? [],
            }
          }))
          setFilterData((prev) => ({
            ...prev,
            department: newDepartments,
          }))

          copyBody = {
            ...copyBody,
            departments: newDepartments,
          }
        }

        return copyBody
      }
    })
  }, [dependientItems?.department])


  return {
    row: row as any[],
    columns,
    total,
    loading,
    headers,
    resendReport,
    disabled,
    snackbar,
    dependientItems,
    detail,
    anchorEl,
    inputFilter,
    filterData,
    setInputFilter,
    optionMenu,
    setAnchorEl,
    closeResendModal,
    handleSendReportData,
    submitResendReport,
    requestTable,
    closeSnackbar,
    selectedIds,
    notFolioSelected,
    HandleCancelFolios,
    setSelectedIds,
    setNotFolioSelected,
    HandleDeleteFolios,
    selectedDepartmentIds,
    notDepartmentSelected,
    departmentsWithFolios,
    ReassignFolios,
    isCreatorOrAdminOrAssing,
    localStatus,
    flagEdit,
    confirmModal,
    isChecked,
    isLoading,
    getDetailInform,
    uuid,
    fetchDepartmentsWithFolios,
    canReassignUser
  }
}

export { useGetData }